import {
  getImgixImageProps,
  type ImageSizes,
} from '@leland-dev/leland-ui-library';
import Image, { type ImageProps } from 'next/image';
import React from 'react';

export type BasePackageAndClassImageProps = Omit<
  ImageProps,
  'src' | 'alt' | 'layout' | 'objectFit' | 'sizes'
> & {
  /**
   * NOTE: must include a width class (e.g. w-18, w-full)
   */
  containerClassName: string;
  name?: string | null;
  imageLink?: string | null;
  sizes: ImageSizes;
  defaultImageProps: { src: string; sizes: string };
};

/**
 * This component will render a Package image in the correct aspect ratio
 *
 * NOTE: to maintain proper aspect ratio, the `containerClassName` must include a width class.
 */
const BasePackageAndClassImage: React.FC<BasePackageAndClassImageProps> = ({
  containerClassName,
  className,
  name,
  imageLink,
  sizes,
  defaultImageProps,
  ...imageProps
}) => {
  const imagePropsWithDefault = imageLink
    ? {
        ...getImgixImageProps({
          sizes,
          src: imageLink,
        }),
      }
    : defaultImageProps;

  return (
    <div className={`${containerClassName}`}>
      <Image
        {...imageProps}
        className={`${className} aspect-entity-image w-full object-cover`}
        alt={name ?? ''}
        height={0}
        width={0}
        {...imagePropsWithDefault}
      />
    </div>
  );
};

export default BasePackageAndClassImage;
